export default __webpack_public_path__ + "static/media/Träslöjd5.4a68d57b.jpeg";